(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initSizeDrawers(root) {
    root.querySelectorAll('[data-size-drawer-picker]').forEach(function (picker) {
      if (picker.dataset.sizeDrawerInit) return;
      picker.dataset.sizeDrawerInit = '1';

      const trigger      = picker.querySelector('[data-drawer-trigger]');
      const overlay      = picker.querySelector('[data-drawer-overlay]');
      const options      = picker.querySelectorAll('[data-drawer-option]');
      const triggerLabel = picker.querySelector('[data-trigger-label]');

      if (!trigger || !overlay) return;

      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      function updateDrawerImages() {
        const variantPicker = picker.closest('variant-picker');
        if (!variantPicker) return;

        const jsonScript = variantPicker.querySelector('script[type="application/json"]');
        if (!jsonScript) return;

        let selectedVariant;
        try {
          selectedVariant = JSON.parse(jsonScript.textContent);
        } catch (e) {
          return;
        }

        if (!selectedVariant) return;

        const variantImage = selectedVariant.featured_image;
        const newSrc = variantImage
          ? variantImage.src + '&width=80'
          : null;

        const triggerImg = trigger.querySelector('.size-drawer-trigger__image');
        if (triggerImg) {
          if (newSrc) {
            triggerImg.src = newSrc;
          }
        }

        options.forEach(function (option) {
          const inputId   = option.dataset.optionInputId;
          const hiddenInput = picker.querySelector(
            `.size-drawer-hidden-input[data-input-id="${inputId}"]`
          );
          const optionImg = option.querySelector('.size-drawer-option__image');
          if (!optionImg || !hiddenInput) return;

          const optionVariantId = hiddenInput.dataset.variantId;
          if (!optionVariantId) return;

          const productUrl = variantPicker.dataset.productUrl;
          if (!productUrl) return;

          getProductVariants(productUrl, function (variants) {
            const matchedVariant = variants.find(function (v) {
              return String(v.id) === String(optionVariantId);
            });
            if (!matchedVariant) return;

            const vImg = matchedVariant.featured_image;
            if (vImg && vImg.src) {
              const baseSrc = vImg.src.split('?')[0];
              const sized   = baseSrc + '?width=100';
              if (optionImg.src !== sized) {
                optionImg.src = sized;
              }
            }
          });
        });
      }
      function setDrawerImagesLoading(isLoading) {
        const triggerImg = trigger.querySelector('.size-drawer-trigger__image');
        if (triggerImg) triggerImg.classList.toggle('is-updating', isLoading);

        options.forEach(function (option) {
          const optionImg = option.querySelector('.size-drawer-option__image');
          if (optionImg) optionImg.classList.toggle('is-updating', isLoading);
        });
      }

      var _variantCache = window.__sizeDrawerVariantCache =
        window.__sizeDrawerVariantCache || {};

      function getProductVariants(productUrl, callback) {
        var handle = productUrl.replace(/\/$/, '').split('/products/')[1];
        if (!handle) { callback([]); return; }

        var cacheKey = handle.split('?')[0];

        if (_variantCache[cacheKey]) {
          if (Array.isArray(_variantCache[cacheKey])) {
            callback(_variantCache[cacheKey]);
          } else {
            _variantCache[cacheKey + '__q'] = _variantCache[cacheKey + '__q'] || [];
            _variantCache[cacheKey + '__q'].push(callback);
          }
          return;
        }

        _variantCache[cacheKey] = '__pending__';

        fetch('/products/' + cacheKey + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var variants = data.variants || [];
            _variantCache[cacheKey] = variants;
            callback(variants);
            var q = _variantCache[cacheKey + '__q'] || [];
            q.forEach(function (cb) { cb(variants); });
            _variantCache[cacheKey + '__q'] = [];
          })
          .catch(function () {
            _variantCache[cacheKey] = [];
            callback([]);
          });
      }

      var variantPickerEl = picker.closest('variant-picker');
if (variantPickerEl) {
  variantPickerEl.addEventListener('change', function (e) {
    if (e.target.classList.contains('size-drawer-hidden-input')) return;
    setDrawerImagesLoading(true);
  });

  variantPickerEl.addEventListener('variant:update', function () {
    updateDrawerImages();
    setDrawerImagesLoading(false);
  });

  variantPickerEl.addEventListener('variantchange', function () {
    updateDrawerImages();
    setDrawerImagesLoading(false);
  });

  variantPickerEl.addEventListener('variant:changed', function () {
    updateDrawerImages();
    setDrawerImagesLoading(false);
  });
}

setTimeout(updateDrawerImages, 0);

      function openDrawer() {
        updateDrawerImages();
        overlay.classList.add('is-open');
        trigger.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        overlay.classList.remove('is-open');
        trigger.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', openDrawer);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDrawer(); }
      });

      overlay.querySelector('[data-drawer-close]')?.addEventListener('click', closeDrawer);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeDrawer();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeDrawer();
      });

      options.forEach(function (option) {
        function selectOption() {
          if (option.dataset.available === 'false') return;

          const inputId     = option.dataset.optionInputId;
          const targetInput = picker.querySelector(
            `.size-drawer-hidden-input[data-input-id="${inputId}"]`
          );

          if (!targetInput) return;

          picker.querySelectorAll('.size-drawer-hidden-input').forEach(function (inp) {
            inp.checked = false;
          });

          targetInput.checked = true;

          options.forEach(function (o) { o.classList.remove('is-selected'); });
          option.classList.add('is-selected');
          if (triggerLabel) triggerLabel.textContent = option.dataset.value;

          targetInput.dispatchEvent(new Event('change', { bubbles: true }));

          closeDrawer();
        }

        option.addEventListener('click', selectOption);
        option.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(); }
        });
      });
    });
  }

  function observeMorphs() {
    const observer = new MutationObserver(function (mutations) {
      let needsInit = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (
              (node.matches && node.matches('[data-size-drawer-picker]')) ||
              (node.querySelector && node.querySelector('[data-size-drawer-picker]'))
            ) {
              needsInit = true;
            }
          }
        });
      });
      if (needsInit) initSizeDrawers(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSizeDrawers(document);
      observeMorphs();
    });
  } else {
    initSizeDrawers(document);
    observeMorphs();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSizeDrawers(e.target);
  });

})();
  } catch(e) { console.error(e); }
})();

})();
